
import { SET_PAYMENT_GATEWAYS_USED } from '../../actions/types/types';

const initState = {
    PaymentGatewaysUsed: [],
};

const paymentGatewaysUsed = (state = initState, action) => {
  switch (action.type) {
    case SET_PAYMENT_GATEWAYS_USED:
      return {
        ...state,
        PaymentGatewaysUsed: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default paymentGatewaysUsed;
